
export const AET_STORE_EVENTS = {
  MCQ_ASSIGNMENT_REQUESTED: 'MCQ_ASSIGNMENT_REQUESTED',
  TOC_MAPPING_REQUESTED: 'TOC_MAPPING_REQUESTED',
  BERLIN_TOC_MAPPING_REQUESTED: 'BERLIN_TOC_MAPPING_REQUESTED',
  MCQ_ASSIGNMENT_COMPLETED: 'MCQ_ASSIGNMENT_COMPLETED',
  MCQ_ASSIGNMENT_FETCHED: 'MCQ_ASSIGNMENT_FETCHED',
  TOC_MAPPING_COMPLETED: 'TOC_MAPPING_COMPLETED',
  MCQ_ASSIGNMENT_FAILED: 'MCQ_ASSIGNMENT_FAILED',
  TOC_MAPPING_FAILED: 'TOC_MAPPING_FAILED',
  ASSET_FETCHED: 'ASSET_FETCHED',
  SYLLABUS_STORE_UPDATED: 'SYLLABUS_STORE_UPDATED',
  ASSIGNMENT_CREATE_REQUESTED: 'ASSIGNMENT_CREATE_REQUESTED',
  ASSIGNMENT_CREATE_COMPLETED: 'ASSIGNMENT_CREATE_COMPLETED',
  ASSIGNMENT_CREATE_FAILED: 'ASSIGNMENT_CREATE_FAILED',
  ASSIGNMENT_GET_REQUESTED: 'ASSIGNMENT_GET_REQUESTED',
  ASSIGNMENT_GET_COMPLETED: 'ASSIGNMENT_GET_COMPLETED',
  ASSIGNMENT_GET_FAILED: 'ASSIGNMENT_GET_FAILED',
  GET_MCQ_STATUS_REQUESTED: 'GET_MCQ_STATUS_REQUESTED',
  GET_MCQ_STATUS_COMPLETED: 'GET_MCQ_STATUS_COMPLETED',
  GET_MCQ_STATUS_FAILED: 'GET_MCQ_STATUS_FAILED',
  INSTRUCTOR_REQUESTED: 'INSTRUCTOR_REQUESTED',
  INSTRUCTOR_COMPLETED: 'INSTRUCTOR_COMPLETED',
  INSTRUCTOR_FAILED: 'INSTRUCTOR_FAILED',
  ASSIGNMENT_DELETE_REQUESTED: 'ASSIGNMENT_DELETE_REQUESTED',
  ASSIGNMENT_DELETE_COMPLETED: 'ASSIGNMENT_DELETE_COMPLETED',
  ASSIGNMENT_DELETE_FAILED: 'ASSIGNMENT_DELETE_FAILED',
  STUDENTS_ROSTER_REQUESTED: 'STUDENTS_ROSTER_REQUESTED',
  STUDENTS_ROSTER_COMPLETED: 'STUDENTS_ROSTER_COMPLETED',
  STUDENTS_COMPLETED: 'STUDENTS_COMPLETED',
  STUDENTS_FAILED: 'STUDENTS_FAILED',
  STUDENTS_ROSTER_FAILED: 'STUDENTS_ROSTER_FAILED',
  COURSE_ASSIGNMENT_PROGRESS_REQUESTED: 'COURSE_ASSIGNMENT_PROGRESS_REQUESTED',
  COURSE_ASSIGNMENT_PROGRESS_COMPLETED: 'COURSE_ASSIGNMENT_PROGRESS_COMPLETED',
  COURSE_ASSIGNMENT_PROGRESS_FAILED: 'COURSE_ASSIGNMENT_PROGRESS_FAILED',
  ASSIGNMENT_ALL_STUDENTS_PROGRESS_REQUESTED: 'ASSIGNMENT_ALL_STUDENTS_PROGRESS_REQUESTED',
  ASSIGNMENT_ALL_STUDENTS_PROGRESS_COMPLETED: 'ASSIGNMENT_ALL_STUDENTS_PROGRESS_COMPLETED',
  ASSIGNMENT_ALL_STUDENTS_PROGRESS_FAILED: 'ASSIGNMENT_ALL_STUDENTS_PROGRESS_FAILED',
  ASSIGNMENT_UPDATE_REQUESTED: 'ASSIGNMENT_UPDATE_REQUESTED',
  ASSIGNMENT_UPDATE_COMPLETED: 'ASSIGNMENT_UPDATE_COMPLETED',
  ASSIGNMENT_UPDATE_FAILED: 'ASSIGNMENT_UPDATE_FAILED',
  ASSIGNMENT_TITLE_REQUESTED: 'ASSIGNMENT_TITLE_REQUESTED',
  ASSIGNMENT_TITLE_COMPLETED: 'ASSIGNMENT_TITLE_COMPLETED',
  ASSIGNMENT_TITLE_FAILED: 'ASSIGNMENT_TITLE_FAILED',
  BULK_EDIT_REQUESTED: 'BULK_EDIT_REQUESTED',
  BULK_EDIT_FAILED: 'BULK_EDIT_FAILED',
  BULK_EDIT_COMPLETED: 'BULK_EDIT_COMPLETED',
  MCQ_STATUS_REQUESTED: 'MCQ_STATUS_REQUESTED',
  AGGREGATE_ASSIGNMENT_MCQ_REQUESTED: 'AGGREGATE_ASSIGNMENT_MCQ_REQUESTED',
  AGGREGATE_ASSIGNMENT_MCQ_COMPLETED: 'AGGREGATE_ASSIGNMENT_MCQ_COMPLETED',
  AGGREGATE_ASSIGNMENT_MCQ_FAILED: 'AGGREGATE_ASSIGNMENT_MCQ_FAILED',
  VIEW_QUESTION_REMEDIATION_OPTIONS: 'VIEW_QUESTION_REMEDIATION_OPTIONS',
  STUDENT_ASSIGNMENT_DUE_DATES_POST_REQUESTED: 'STUDENT_ASSIGNMENT_DUE_DATES_POST_REQUESTED',
  STUDENT_ASSIGNMENT_DUE_DATES_POST_COMPLETED: 'STUDENT_ASSIGNMENT_DUE_DATES_POST_COMPLETED',
  STUDENT_ASSIGNMENT_DUE_DATES_POST_FAILED: 'STUDENT_ASSIGNMENT_DUE_DATES_POST_FAILED',
  STRUGGLE_STUDENTS_REQUESTED: 'STRUGGLE_STUDENTS_REQUESTED',
  STRUGGLE_STUDENTS_COMPLETED: 'STRUGGLE_STUDENTS_COMPLETED',
  STRUGGLE_STUDENTS_FAILED: 'STRUGGLE_STUDENTS_FAILED',
  DIFFICULT_QUESTIONS_REQUESTED: 'DIFFICULT_QUESTIONS_REQUESTED',
  DIFFICULT_QUESTIONS_COMPLETED: 'DIFFICULT_QUESTIONS_COMPLETED',
  DIFFICULT_QUESTIONS_FAILED: 'DIFFICULT_QUESTIONS_FAILED',
  QUESTION_STATISTICS_REQUESTED: 'QUESTION_STATISTICS_REQUESTED',
  QUESTION_STATISTICS_COMPLETED: 'QUESTION_STATISTICS_COMPLETED',
  QUESTION_STATISTICS_FAILED: 'QUESTION_STATISTICS_FAILED',
  AET_MCQ_FEEDBACK_REQUESTED: 'AET_MCQ_FEEDBACK_REQUESTED',
  AET_MCQ_FEEDBACK_COMPLETED: 'AET_MCQ_FEEDBACK_COMPLETED',
  AET_MCQ_FEEDBACK_FAILED: 'AET_MCQ_FEEDBACK_FAILED',
  CHANGE_COURSE_USER_ROLE_REQUESTED: 'CHANGE_COURSE_USER_ROLE_REQUESTED',
  CHANGE_COURSE_USER_ROLE_COMPLETED: 'CHANGE_COURSE_USER_ROLE_COMPLETED',
  CHANGE_COURSE_USER_ROLE_FAILED: 'CHANGE_COURSE_USER_ROLE_FAILED'
};

// TODO:: any better way to make this dynamic?
export const DUE_DATE_EXTENSION_EXTRA_DAYS_ORDERED = [0, 2, 3, 5, 7, 14];
export const DUE_DATE_EXTENSION_OPTION_MESSAGE_KEY_PREFIX = 'aet.studentRoster.dueDateAdjustment.option';
export const DEFAULT_DUE_DATE_EXTENSION_EXTRA_DAYS = 0;

export const ASSIGNMENT_TYPES = {
  QUIZ: 'QUIZ',
  HOMEWORK: 'HOMEWORK'
};

export const ASSIGNMENT_STATUS_TYPES = {
  ASSIGNED: 'ASSIGNED',
  ASSIGNABLE: 'ASSIGNABLE',
  ALL: 'ALL'
};

export const SYLLABUS_UPLOAD_VIEW = {
  CORE: 'core',
  LIST: 'list'
};

export const SYLLABUS_UPLOAD_VIEW_VALUES = Object.values(SYLLABUS_UPLOAD_VIEW);

export const ASSIGNMENT_FORM_LAYOUT = {
  SINGLE: 'single',
  SPLIT: 'split'
};

export const ASSIGNMENT_GET_QUERY = {
  INSTRUCTOR: { assignmentStatus: ASSIGNMENT_STATUS_TYPES.ALL },
  STUDENT: { assignmentStatus: ASSIGNMENT_STATUS_TYPES.ASSIGNED }
};
export const DEFAULT_STUDENT_ANSWER_CONFIDENCE = 'Needs work';

export const TIME_FORMATS = {
  DEFAULT: '23:59',
  DEFAULT_HOUR: 23,
  DEFAULT_MINUTE: 59
};

export const PREFIX_ASSIGNMENT = 'assignment';

export const ANSWER_CONFIDENCE_MAP = ['great', 'gettingThere', 'needsReview'];

export const ANSWER_CONFIDENCE_MAP_LABEL = {
  Great: 'aet.home.segmentGreatLabel',
  'Getting There': 'aet.home.segmentGettingThereLabel',
  'Needs review': 'aet.home.segmentNeedsReviewLabel'
};

export const ASSIGNMENT_CRUD_FIELDS = {
  MEDIA_AND_QUESTION: 'MediaAndQuestion',
  ASSESSMENT: 'ASSESSMENT',
  ACTIVITY_TYPE_IPX: 'Ipx',
  SCORING_MODE_NORMAL: 'Normal'
};

// When true, delete and bulk-edit are restricted for in-progress assignments.
// Edit is not gated by this flag (PPCOREAH-926/927).
export const DISABLE_DELETE_ACTIONS = true;
export const SYLLABUS_PERSISTENCE_ENABLED = false;
export const SYLLABUS_LOADER_OPERATIONS = {
  TITLE_GENERATION: 'titleGeneration',
  TOC_MAPPING: 'tocMapping'
};

export const TOC_MAPPING_STRATEGY_CONFIG = {
  PRISM_DETERMINISTIC: { value: 1, responseSource: 'prism' },
  PRISM_LLM: { value: 2, responseSource: 'prism' },
  BERLIN_GRAPH: { value: 3, responseSource: 'berlin' },
  EXTENSION: { value: 4, responseSource: null }
};

export const TOC_MAPPING_STRATEGY = Object.fromEntries(
  Object.entries(TOC_MAPPING_STRATEGY_CONFIG).map(([key, cfg]) => [key, cfg.value])
);

export const TOC_MAPPING_RESPONSE_SOURCE = {
  PRISM: TOC_MAPPING_STRATEGY_CONFIG.PRISM_DETERMINISTIC.responseSource,
  BERLIN: TOC_MAPPING_STRATEGY_CONFIG.BERLIN_GRAPH.responseSource
};

/** LD default for variant 3 Berlin TOC mapping graph (graphId/version/useStream). */
export const DEFAULT_SYLLABUS_TOC_MAPPING_GRAPH = {
  graphId: '2193d085-d925-40da-9f2d-95b0e99f8eb0',
  version: 1,
  useStream: true
};

export const LAST_ASSIGNMENT_DEFAULTS_KEY = 'last_assignment_persistence';

export const ASSIGNMENT_TITLE_CONFIG = {
  MAX_LENGTH_KEY: 'MAX_ASSIGNMENT_TITLE_LENGTH',
  SUPPORTED_CHAR_KEY: 'SUPPORTED_CHAR',
  ASSIGNMENT_TITLE_HELPER_TEXT: 'ASSIGNMENT_TITLE_HELPER_TEXT'
};

export const DEFAULT_MAX_ASSIGNMENT_TITLE_LENGTH = 128;
export const DEFAULT_SUPPORTED_CHAR = '[^a-zA-Z0-9_\\s]';

export const USE_ASSIGNMENT_PLAY_ORDER_SORT = true;
export const SEGMENTED_TAB_VALUES = {
  DIFFICULT_QUESTIONS: 'difficult_questions',
  STUDENTS: 'students',
  ASSIGNMENTS: 'Assignments'
};

export const ASSIGNMENT_L2_PAGE = 'assignmentL2Page';
export const STUDENT_L2_PAGE = 'studentL2page';

/**
 * API risk fields → badge copy (`riskKey` = numeric field on each row).
 * @type {Array<{ labelKey: string, riskKey: string }>}
 */

/** Difficult questions → Question insights column order. */
export const INSIGHT_RISK_BADGES_QUESTION = [
  { riskKey: 'incorrectFirstAttemptRisk', labelKey: 'aet.home.insightRisk.incorrectFirstAttempts' },
  { riskKey: 'multipleIncorrectAttemptsRisk', labelKey: 'aet.home.insightRisk.multipleIncorrectAttempts' },
  { riskKey: 'lowConfidenceRisk', labelKey: 'aet.home.insightRisk.lowConfidence' },
  { riskKey: 'mediumConfidenceRisk', labelKey: 'aet.home.insightRisk.mediumConfidence' },
  { riskKey: 'engagementRisk', labelKey: 'aet.home.insightRisk.didNotAttempt' }
];

/** Struggling students → Performance indicators column order. */
export const INSIGHT_RISK_BADGES_STUDENT = [
  { riskKey: 'lowConfidenceRisk', labelKey: 'aet.home.insightRisk.lowConfidence' },
  { riskKey: 'mediumConfidenceRisk', labelKey: 'aet.home.insightRisk.mediumConfidence' },
  { riskKey: 'engagementRisk', labelKey: 'aet.home.insightRisk.lowEngagement' },
  { riskKey: 'incorrectFirstAttemptRisk', labelKey: 'aet.home.insightRisk.incorrectFirstAttempts' },
  { riskKey: 'multipleIncorrectAttemptsRisk', labelKey: 'aet.home.insightRisk.multipleIncorrectAttempts' }
];

/** API field for low engagement / N/A insight risk on question and student rows. */
export const ENGAGEMENT_INSIGHT_RISK_KEY = 'engagementRisk';

/** i18n key for list-view N/A engagement insight badge label. */
export const INSIGHT_RISK_NA_LABEL_KEY = 'aet.home.insightRisk.na';

/** Difficult-topic details → circular graph order and count/total field mapping. */
export const INSIGHT_BEHAVIOR_TRENDS_QUESTION = [
  {
    id: 'attempted',
    labelKey: 'aet.home.insightRisk.attempted',
    countField: 'studentsWhoAttempted',
    totalSource: 'roster' // only this must be roster, as this needs totalstudents count
  },
  {
    id: 'incorrectFirstAttemptRisk',
    labelKey: 'aet.home.insightRisk.incorrectFirstAttempts',
    countField: 'failedFirstAttemptCount',
    totalSource: 'studentsWhoAttempted'
  },
  {
    id: 'multipleIncorrectAttemptsRisk',
    labelKey: 'aet.home.insightRisk.multipleIncorrectAttempts',
    countField: 'manyIncorrectAttemptsCount',
    totalSource: 'studentsWhoAttempted'
  },
  {
    id: 'lowConfidenceRisk',
    labelKey: 'aet.home.insightRisk.lowConfidence',
    countField: 'lowConfidenceCount',
    totalSource: 'studentsWhoAttempted'
  },
  {
    id: 'mediumConfidenceRisk',
    labelKey: 'aet.home.insightRisk.mediumConfidence',
    countField: 'mediumConfidenceCount',
    totalSource: 'studentsWhoAttempted'
  }
];

/** Fallback threshold for showing insight risk badges. */
export const INSIGHT_RISK_BADGE_DISPLAY_THRESHOLD = 0;

/** Fallback limit for row level badges */
export const INSIGHT_RISK_BADGE_TABLE_LIMIT = 3;
/** Fallback for only difficult questions */
export const OVERALL_DIFFICULTY_RISK_MIN_DISPLAY_THRESHOLD = 20;

/** Fallback for only struggling students */
export const OVERALL_STUDENT_RISK_MIN_DISPLAY_THRESHOLD = 20;

/** `heroView` Marquee/AWS keys for AET insight thresholds (see InstructorDashboardUtils.getAetInsightsThresholdConfig). */
export const AET_INSIGHTS_THRESHOLD = {
  INSIGHT_RISK_BADGE_DISPLAY_THRESHOLD: 'INSIGHT_RISK_BADGE_DISPLAY_THRESHOLD',
  INSIGHT_RISK_BADGE_TABLE_LIMIT: 'INSIGHT_RISK_BADGE_TABLE_LIMIT',
  OVERALL_DIFFICULTY_RISK_MIN_DISPLAY: 'OVERALL_DIFFICULTY_RISK_MIN_DISPLAY',
  OVERALL_STUDENT_RISK_MIN_DISPLAY: 'OVERALL_STUDENT_RISK_MIN_DISPLAY'
};


export const TOPIC_STYLES = 'topicStyles';

export const REPORT_QUESTION_REASONS = [
  {
    id: 'notRelevant',
    label: 'aet.home.reportQuestion.notRelevant',
    value: 'Not relevant'
  },
  {
    id: 'notCorrect',
    label: 'aet.home.reportQuestion.notCorrect',
    value: 'Not correct'
  },
  {
    id: 'unsafe',
    label: 'aet.home.reportQuestion.unsafe',
    value: 'Unsafe/Harmful'
  },
  {
    id: 'somethingElse',
    label: 'aet.home.reportQuestion.somethingElse',
    value: 'Something else'
  }
];

export const SHOW_PATTERN_IN_AI_USE = false;

export const SHOW_MOST_DIFFICULT_QUESTIONS = false;

export const ASSISTED_BY_AI = 'AI';
export const USED_STUDY_PREP = 'channels_video';

/** Set SEARCH or SORT to false to disable Tabular search UI / primary search columns or column sorting across AET dashboards. */
export const TABULAR_SEARCH_SORT = {
  SEARCH: true,
  SORT: true
};

/** `normalizeDateString` sets `action` to one of these values */
export const SYLLABUS_DATE_NORMALIZATION_ACTION = {
  YEAR_ADJUSTED: 'YEAR_ADJUSTED',
  MANUAL_ENTRY_REQUIRED: 'MANUAL_ENTRY_REQUIRED'
};

/** `coverageDuplicationUtils` sets `coverageDedupeAction` to one of these values */
export const SYLLABUS_COVERAGE_DEDUPE_ACTION = {
  ADJUSTED: 'COVERAGE_ADJUSTED'
};

/** `icon` values returned by `validationUtils.getAssignmentRowStatus` */
export const ASSIGNMENT_ROW_STATUS_ICON = {
  INFO: 'info',
  WARNING: 'warning'
};

/** Date-related error types that can be synced with normalized dates */
export const SYLLABUS_DATE_ERROR_TYPES = [
  'PAST_DUE_DATE',
  'INVALID_DATE',
  'NO_DATE'
];

export const ASSISTED_SCHEDULE_DAY_KEYS = ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'];

export const ASSISTED_SCHEDULE_DAY_MESSAGE_KEYS = {
  M: 'aet.bulkEdit.monday',
  T: 'aet.bulkEdit.tuesday',
  W: 'aet.bulkEdit.wednesday',
  Th: 'aet.bulkEdit.thursday',
  F: 'aet.bulkEdit.friday',
  S: 'aet.bulkEdit.saturday',
  Su: 'aet.bulkEdit.sunday'
};
